import {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useHistory} from 'react-router-dom';
import get from 'lodash.get';


const useModuleAccessCheck = () => {
  const currentUser = useSelector(state => state.auth.currentUser);
  const history = useHistory();

  useEffect(() => {
    const roleCRM = get(currentUser, 'roleCRM', 'No Access');
    if (currentUser && roleCRM === 'No Access') {
      alert(`You do not have access to KBI's CRM module. Contact IT if you would like to request access.`);
      window.location.href = 'https://auth.kbi.works';
    }
  }, [currentUser, history]);
};

export default useModuleAccessCheck;
